import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

import { SHIPPING_REASONS } from '../forms/service/constants';

import './ShippingReasons.scss';
import Checkbox from './ui/Checkbox';
import Input from './ui/Input';

interface IShippingReasonsProps {
  /** aktuell gewählte Gründe (Klartext, so wie sie im JSON landen) */
  values?: string[];
  /** Freitext für einen Grund, der nicht in der Liste steht */
  other?: string;
  onToggle: (reasons: string[]) => void;
  onOtherChange: React.ChangeEventHandler<HTMLInputElement | HTMLSelectElement>;
  hasError?: boolean;
}

const ShippingReasons: FC<IShippingReasonsProps> = ({
  values,
  other,
  onToggle,
  onOtherChange,
  hasError = false
}) => {
  const selected = values || [];

  const toggle = (reason: string): void => {
    onToggle(
      selected.includes(reason)
        ? selected.filter(item => item !== reason)
        : [ ...selected, reason ]
    );
  };

  return (
    <div className={classNames('shipping-reasons', {
      'has-error': hasError && selected.length === 0
    })}>
      <label>Grund der Einsendung:*</label>
      <p className="shipping-reasons-hint">Mehrfachauswahl möglich</p>

      <div className="shipping-reasons-grid">
        {SHIPPING_REASONS.map(reason => (
          <div
            key={reason}
            className={classNames('shipping-reasons-item', {
              'is-selected': selected.includes(reason)
            })}
          >
            <Checkbox
              name="shipping_reasons"
              checked={selected.includes(reason)}
              onChange={() => toggle(reason)}
            >
              {reason}
            </Checkbox>
          </div>
        ))}
      </div>

      <div className="shipping-reasons-other">
        <Input
          value={other}
          label="Anderer Grund (optional)"
          name="shipping_reason_other"
          onChange={onOtherChange}
          placeholder="Falls der Grund oben nicht aufgeführt ist..."
        />
      </div>
    </div>
  );
};

export default ShippingReasons;
